import styled from 'styled-components'

export const ContainerListItemDefault = styled.div`
  width: 100%;
  padding: 0 24px;
  .listItemBase__container__containerMain {
    padding: 16px 0px;
  }
  .listItemBase--inset .divider,
  .listItemBase--contained .divider {
    width: 100%;
  }
  .listItemBase--inset,
  .listItemBase--contained {
    width: 100%;
  }
`
